import { StyleSheet } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  modalTitleStyle: { marginTop: 16 },
  containerStyle: theme => ({
    paddingHorizontal: 0,
    fontSize: 16,
    backgroundColor: theme.colors.backgroundColor,
    borderTopLeftRadius: 6,
    borderTopRightRadius: 6,
    marginBottom: 0,
    height: '100%',
  }),
  subTitleText: {
    fontSize: 24,
    lineHeight: 25,
    fontFamily: Fonts.type.VodafoneLt,
    marginLeft: 16,
    marginTop: 16,
  },
  inputContainer: { marginTop: 41, marginHorizontal: 16 },
  primaryBtn: { marginTop: 40, marginHorizontal: 16 },
  btnContainer: { fontSize: 18 },
  secondaryBtn: { marginTop: 16, marginHorizontal: 16 },
  statusViewContainer: { paddingHorizontal: 16.2 },
  disabledBUttonStyle: theme => ({
    backgroundColor: theme.colors.buttons.disabled,
  }),
  disabledTextStyle: theme => ({ color: theme.colors.textButtons.disabled }),
  description: { fontSize: 18.8, marginBottom: 55, marginHorizontal: 84 },
});
